import { $authHost } from "./fetch"

export const actionSell = async (game, server, coins, amount) => {
    
    const { data } = await $authHost.post( 
        'sell',
        {
            game, server, coins, amount
        } 
    )

    return data
}